import {Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {environment} from '@env/environment';
import { Meta } from '@angular/platform-browser';
import {authCodeFlowConfig} from './sso.config';
import {JwksValidationHandler} from 'angular-oauth2-oidc-jwks';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'idall-oauth-tools';

  constructor(
    private oAuthService: OAuthService,
    private meta: Meta) {
  }

  ngOnInit(): void {
    this.meta.addTag({ name: 'version', content: environment.version });

  }

}
